import cx from 'classnames';
import React, { CSSProperties, ReactNode } from 'react';
import styles from './EmptyData.module.scss';

interface IProps {
  desc?: ReactNode;
  className?: string;
  style?: CSSProperties;
}

const EmptyData = ({ desc = 'Нет данных', className, style }: IProps) => {
  return (
    <div style={style} className={cx(styles.emptyData, className)}>
      {desc}
    </div>
  );
};

export default EmptyData;
